export const categories = [
  { id: "morisxiu", name: "51吃瓜莫里秀", slug: "morisxiu", description: "莫里秀独家爆料，网红明星私密黑料大起底", icon: "ri-vip-crown-line", featured: true },
  { id: "british-museum", name: "大英博物馆", slug: "british-museum", description: "大英博物馆背后的秘密，文化圈深度解析", icon: "ri-bank-line", featured: true },
  { id: "star-scandal", name: "明星翻车", slug: "star-scandal", description: "明星翻车现场，实锤黑料一网打尽", icon: "ri-sparkling-line", featured: true },
  { id: "wanghong", name: "网红黑料", slug: "wanghong", description: "网红圈内幕曝光，塌房现场全程记录", icon: "ri-live-line", featured: true },
  { id: "latest", name: "最新爆料", slug: "latest", description: "全网最新吃瓜动态，第一时间追踪", icon: "ri-fire-line", featured: true },
  { id: "deep-dive", name: "深度解析", slug: "deep-dive", description: "深度挖掘事件真相，不放过任何细节", icon: "ri-search-eye-line", featured: false },
];

export const hotTopics = [
  {
    id: 1,
    title: "51吃瓜莫里秀",
    subtitle: "独家揭秘莫里秀最新内幕",
    description: "莫里秀最新一期爆料内容全面升级，多位一线明星卷入风波，独家深扒不为人知的幕后故事",
    image: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20news%20studio%20set%20with%20dramatic%20red%20and%20black%20lighting%2C%20microphone%20on%20stage%2C%20breaking%20news%20atmosphere%2C%20cinematic%20photography%20with%20film%20grain%20texture%2C%20mysterious%20and%20intense%20mood%2C%20professional%20lighting%20setup&width=800&height=1067&seq=topic-morisxiu-01&orientation=portrait",
    category: "morisxiu",
    tag: "热门",
    tagColor: "bg-accent-500",
  },
  {
    id: 2,
    title: "大英博物馆",
    subtitle: "文化圈地震级爆料",
    description: "大英博物馆文物风波持续发酵，多国联合声明引发全球关注，背后真相令人震惊",
    image: "https://readdy.ai/api/search-image?query=Grand%20museum%20interior%20with%20dramatic%20shadows%20and%20warm%20golden%20lighting%2C%20ancient%20artifacts%20displayed%20in%20glass%20cases%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%20with%20deep%20contrast%2C%20film%20grain%20texture%20overlay%2C%20dark%20academic%20aesthetic&width=800&height=1067&seq=topic-museum-02&orientation=portrait",
    category: "british-museum",
    tag: "爆款",
    tagColor: "bg-primary-500",
  },
  {
    id: 3,
    title: "明星翻车现场",
    subtitle: "顶流塌房全记录",
    description: "当红明星人设崩塌全过程还原，从爆料到实锤完整时间线，带你直击翻车第一现场",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20event%20with%20paparazzi%20flash%20photography%2C%20celebrity%20silhouette%20in%20spotlight%2C%20chaotic%20media%20scene%2C%20high%20contrast%20black%20and%20red%20color%20scheme%2C%20film%20grain%20texture%2C%20breaking%20news%20aesthetic%2C%20intense%20dramatic%20lighting&width=800&height=1067&seq=topic-scandal-03&orientation=portrait",
    category: "star-scandal",
    tag: "实锤",
    tagColor: "bg-secondary-500",
  },
];

export const articles = [
  {
    id: 1,
    title: "莫里秀最新爆料：知名导演与新晋女星深夜密会被拍，酒店监控视频流出",
    excerpt: "据知情人士透露，该导演已有家室，此次事件在圈内引发轩然大波。监控画面显示两人先后进入同一酒店，停留时间长达四小时。",
    content: `近日，51吃瓜莫里秀团队获得了一段重磅监控视频，内容涉及圈内一位知名导演与一位新晋女星的深夜密会。据莫里秀独家消息源透露，这段视频拍摄于上周六凌晨两点左右，地点位于北京某五星级酒店的地下停车场。

从监控画面中可以看到，导演先从一辆黑色商务车上下来，随后新晋女星紧随其后，两人在酒店门口短暂停留后，一同进入酒店电梯间。据酒店内部工作人员透露，两人进入房间后，直到凌晨六点才先后离开，停留时间长达近四小时。

该导演在圈内一直以"好男人"形象示人，与妻子结婚已有十五年，育有两个孩子。此次事件曝光后，其社交媒体评论区已经沦陷，大量粉丝表示失望和愤怒。有圈内人士透露，这位导演与女星的"合作"其实早在去年就已经开始了，只是此次被莫里秀团队抓到了实锤。

新晋女星方面，其经纪公司目前尚未做出任何回应。但据知情人士称，该公司内部已经召开了紧急会议，讨论公关策略。这位女星今年刚满25岁，去年凭借一部青春偶像剧走红，目前正在拍摄某大IP改编剧的女二号。

值得关注的是，这段监控视频之所以能够被莫里秀团队获取，据说与酒店内部员工的"正义感"有关。该员工在接受莫里秀采访时表示，自己看不惯某些人在公共场所肆无忌惮的行为，才决定将视频提供给媒体。

目前，该导演和新晋女星的工作室均未对此事发表任何声明。莫里秀团队表示，后续还将放出更多相关证据，包括两人在片场的互动视频，以及同剧组人员的匿名爆料。吃瓜群众们，请持续关注51吃瓜官网，我们带你直击第一现场。`,
    image: "https://readdy.ai/api/search-image?query=Night%20city%20street%20scene%20with%20luxury%20hotel%20entrance%2C%20dramatic%20moody%20lighting%2C%20paparazzi%20style%20photography%2C%20blurred%20figures%20in%20background%2C%20cinematic%20noir%20aesthetic%2C%20rainy%20pavement%20reflections%2C%20dark%20and%20mysterious%20atmosphere&width=800&height=560&seq=article-01&orientation=landscape",
    category: "morisxiu",
    categoryName: "51吃瓜莫里秀",
    date: "2026-07-01",
    views: 128000,
    comments: 3420,
    tag: "独家",
    tagColor: "bg-primary-500",
    featured: true,
  },
  {
    id: 2,
    title: "大英博物馆文物来源遭多方质疑，多国要求归还本国文物",
    excerpt: "国际社会对大英博物馆馆藏文物来源的质疑声浪日益高涨，多个国家正式提出文物归还要求。",
    content: `大英博物馆近日再次陷入舆论风暴。继去年部分文物被盗事件曝光后，国际社会对该馆馆藏文物来源的质疑声浪日益高涨。据不完全统计，目前已有超过十个国家正式或半正式地向英国政府提出文物归还要求。

这些文物涉及范围极广，从古希腊雕塑到埃及木乃伊，从中国敦煌壁画到非洲贝宁青铜器。其中，希腊方面对帕特农神庙大理石浮雕的归还呼声最为强烈。希腊文化部长在接受采访时表示："这些文物是被非法掠夺的，它们理应回到祖国。"

中国方面，中国文物局近日也发声，要求大英博物馆归还从中国掠夺的超过23000件文物。其中包括敦煌藏经洞的经卷、圆明园的瓷器、以及大量从紫禁城流出的珍贵文物。有专家表示，这些文物的流失与近代史上的战争和不平等条约密切相关。

尼日利亚则通过外交渠道正式致函英国政府，要求归还1897年英国军队掠夺的贝宁青铜器。这批文物原本属于贝宁王国，具有极高的历史和艺术价值。

面对国际压力，大英博物馆方面回应称，其藏品是"全人类共同的遗产"，并表示愿意通过长期借展的方式与来源国合作。然而，这一表态被多国批评为"敷衍"和"傲慢"。

有法律专家指出，根据1970年联合国教科文组织《关于禁止和防止非法进出口文化财产和非法转让其所有权的方法的公约》，来源国完全有权要求归还被掠夺的文物。但目前英国尚未签署该公约的某些关键条款，使得法律追索面临诸多障碍。

51吃瓜官网将持续追踪大英博物馆文物风波的最新进展。吃瓜无罪，八卦有理，我们将为你带来第一手深度解析。`,
    image: "https://readdy.ai/api/search-image?query=British%20Museum%20exterior%20with%20protesters%20holding%20signs%2C%20dramatic%20overcast%20sky%2C%20documentary%20style%20photography%2C%20classical%20architecture%20columns%2C%20serious%20atmosphere%2C%20high%20contrast%20black%20and%20white%20tones%20with%20subtle%20warm%20accents&width=800&height=560&seq=article-02&orientation=landscape",
    category: "british-museum",
    categoryName: "大英博物馆",
    date: "2026-06-30",
    views: 256000,
    comments: 8900,
    tag: "热榜",
    tagColor: "bg-accent-500",
    featured: true,
  },
  {
    id: 3,
    title: "顶流男星深夜直播翻车：口误爆出惊天秘密，粉丝集体脱粉",
    excerpt: "该男星在凌晨直播中疑似醉酒，口无遮拦爆出与多名女星的不正当关系，直播间瞬间炸锅。",
    content: `昨日凌晨，娱乐圈再次发生地震级翻车事件。一位拥有超过五千万粉丝的顶流男星在凌晨三点的直播中，疑似醉酒状态下口无遮拦，连续爆出多个惊天秘密，导致直播间瞬间涌入超过百万观众，相关话题迅速登上热搜榜首。

事情的起因是该男星在直播中提到自己"最近心情不好，想找人聊聊"。随后，他开始断断续续地讲述自己与前经纪公司解约期间的种种遭遇。在情绪激动的状态下，他脱口而出："你以为那几个人真的那么干净吗？我跟你说，她们的事比我复杂多了。"

此言一出，直播间弹幕瞬间刷屏。有网友追问"哪些人"，该男星在酒精的作用下，竟然直接说出了三位当红女星的名字，并暗示与她们之间存在"超出友谊的关系"。更令人震惊的是，他还透露其中一位女星"背后有大佬撑腰"，并表示"等我把证据整理好再细说"。

直播持续了约四十分钟，期间该男星的经纪人多次尝试中断直播，但均未成功。直到该男星说出"反正我也没什么可失去的了"之后，直播画面才被强制切断。

直播结束后，该男星迅速删除了直播回放，但早有准备的网友们已经将关键片段录屏并广泛传播。截至发稿时，与该男星相关的三个话题同时占据热搜前三位，其微博评论区已关闭。

三位被点名的女星中，已有两人通过工作室发布声明否认，并表示"保留追究法律责任的权利"。另一位女星则保持沉默，其工作室的微博也被粉丝攻陷。

业内人士分析，此次事件将对该男星的演艺事业造成毁灭性打击。据悉，他目前有三部待播剧和五个代言合约，品牌方已经开始评估违约风险。

51吃瓜官网将持续关注此次翻车尾盘的最新发展。全网独家吃瓜爆料入口已更新，请锁定51吃瓜。`,
    image: "https://readdy.ai/api/search-image?query=Smartphone%20live%20streaming%20screen%20with%20dramatic%20chat%20messages%20flooding%2C%20dark%20room%20with%20screen%20glow%2C%20social%20media%20interface%2C%20tense%20dramatic%20atmosphere%2C%20digital%20age%20aesthetic%2C%20warm%20screen%20light%20on%20dark%20background&width=800&height=560&seq=article-03&orientation=landscape",
    category: "deep-dive",
    categoryName: "深度解析",
    date: "2026-06-29",
    views: 198000,
    comments: 15600,
    tag: "实锤",
    tagColor: "bg-secondary-500",
    featured: true,
  },
  {
    id: 4,
    title: "知名网红被前男友曝光聊天记录，人设崩塌引发全网热议",
    excerpt: "一段长达两年的私密聊天记录被曝光，内容涉及虚假人设打造、粉丝割韭菜等众多丑闻。",
    content: `又一位千万粉丝级别的网红翻车了。昨日，一位自称是该网红前男友的男子在微博上发布了一系列聊天记录截图，内容涉及虚假人设打造、粉丝经济收割、以及大量不堪入目的私密对话。该微博在发布后的两小时内转发量超过十万，评论区彻底失控。

根据曝光的聊天记录，这位以"独立女性"和"励志创业"人设走红的女网红，其实背后有专业的MCN机构操盘。聊天记录显示，她的"创业故事"完全是MCN精心策划的剧本，包括创业的起始资金、遇到困难、最终成功的每一个环节都是提前设计好的。

更令人震惊的是，聊天记录中多次出现"割韭菜""收智商税""粉丝就是提款机"等字眼。该网红甚至在一次对话中说："今天直播卖了八十万，佣金四十万，这帮人太好骗了，说两句煽情的话就开始下单。"

此外，聊天记录还揭露了该网红所谓的"单身励志女性"人设也是假的。她与这位前男友实际上同居了两年多，期间多次用恋爱关系作为"素材"在社交媒体上制造话题。分手后，该男子发现她在微博上暗示自己是"被渣男伤害"的受害者，引发粉丝对所谓"渣男"的网暴。

前男友在微博中表示，自己之所以选择曝光，是因为"实在看不惯她一边利用粉丝赚钱，一边把粉丝当傻子"。他还透露，手里还有更多录音和视频证据，如果该网红继续装无辜，他将全部公开。

该网红方面至今未做出任何回应。但据内部人士透露，其签约的MCN机构已经召开紧急会议，正在评估是否要与她解约。同时，多个与该网红合作的品牌方已经暂停了相关推广活动。

此次事件再次引发了公众对网红经济的信任危机。有网友评论："以后再也不相信网红的励志故事了，全是剧本。"也有粉丝表示："当初真情实感地支持她，现在觉得自己像个笑话。"

51吃瓜官网将持续追踪此事的最新进展。吃瓜无罪，八卦有理。`,
    image: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20chat%20messages%20on%20dark%20desk%2C%20dramatic%20lighting%20from%20screen%2C%20social%20media%20scandal%20concept%2C%20mysterious%20mood%2C%20cinematic%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20screen%20glow%20contrasting%20dark%20surroundings&width=800&height=560&seq=article-04&orientation=landscape",
    category: "wanghong",
    categoryName: "网红黑料",
    date: "2026-06-28",
    views: 89000,
    comments: 4200,
    tag: "热门",
    tagColor: "bg-accent-500",
  },
  {
    id: 5,
    title: "某选秀节目导师私下收取学员好处费，录音证据曝光",
    excerpt: "一段疑似某知名选秀节目导师与学员经纪人的通话录音在网络上疯传，内容涉及金钱交易和名额内定。",
    content: `选秀节目圈再起波澜。昨日，一段时长约八分钟的通话录音在网络上疯传，内容涉及某知名选秀节目导师与学员经纪人之间的金钱交易对话。录音中，双方就"保送进决赛"的价格进行了详细讨论，令人咋舌。

这段录音的发布者声称自己是一位前选秀节目工作人员，因看不惯节目组的暗箱操作而选择曝光。录音中，导师的声音清晰可辨，他在对话中表示："上次那个给了二十万，最后排第七，算是物有所值。这次你想要什么名次，报个价就行。"

学员经纪人则在录音中试图讨价还价，表示"三十万太多了，能不能便宜点"，并暗示"如果这次能进前三，后续还有更多的合作机会"。导师回应："进前三至少五十万起步，而且得是先付全款，上次有个拖账的，到现在还没给齐。"

录音曝光后，迅速在网络上引发轩然大波。不少网友表示，终于知道了为什么有些明明实力一般的选手总能走得那么远。也有网友翻出往届选秀节目的最终排名，试图找出哪些选手可能是"买"来的名次。

该选秀节目的制作方在事件发酵数小时后发布声明，称"正在核实录音的真实性"，并表示"如果属实，将严肃处理相关责任人"。然而，这一回应被网友普遍认为是"拖延时间、等热度过去"。

被牵扯其中的导师目前尚未做出任何回应。但据知情人士透露，该导师已经更换了手机号码，并取消了近期所有的公开行程。

值得注意的是，这已经不是选秀节目第一次爆出此类丑闻。此前，多个选秀节目都曾被爆出过类似的黑幕，包括内定冠军、票数造假、导师收受好处费等。每一次曝光后，节目方都会承诺"整改"，但下一次选秀季，类似的问题依然会出现。

法律专家表示，如果录音内容属实，涉事导师和经纪人可能面临商业贿赂的法律追责。但前提是录音的来源和真实性需要得到确认。

51吃瓜官网将持续关注此事的最新发展。我们将第一时间为你带来最新的实锤和深度解析。`,
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20empty%20judges%20seats%2C%20behind%20the%20scenes%20atmosphere%2C%20dark%20backstage%20area%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20mysterious%20and%20tense%20mood%2C%20professional%20stage%20production%20setup&width=800&height=560&seq=article-05&orientation=landscape",
    category: "star-scandal",
    categoryName: "明星翻车",
    date: "2026-06-27",
    views: 167000,
    comments: 7800,
    tag: "独家",
    tagColor: "bg-primary-500",
  },
  {
    id: 6,
    title: "莫里秀团队深挖：某国际品牌代言人背后的商业黑幕",
    excerpt: "莫里秀团队历时三个月调查，揭露某国际奢侈品牌代言人与品牌方之间的灰色利益链条。",
    content: `51吃瓜莫里秀团队历时三个月的深入调查，今日正式曝光一起涉及某国际奢侈品牌代言人的重大商业黑幕。调查显示，这位备受瞩目的代言人与品牌方之间存在着一条鲜为人知的灰色利益链条，涉及金额可能高达数千万元。

莫里秀的调查始于今年年初。当时，一位自称是该品牌前员工的爆料人联系了莫里秀团队，声称手里有大量关于该品牌中国区营销操作的内部资料。经过三个月的核实和追踪，莫里秀团队整理出了一份详尽的调查报告。

调查的核心发现是：该品牌在中国区选择代言人的标准，并非基于艺人的形象、影响力或市场价值，而是取决于艺人背后经纪公司愿意支付的"渠道费用"。换句话说，谁能给营销总监塞的钱最多，谁就能拿到代言合约。

这位被曝光的代言人，表面上是一位人气极高的流量明星，实际上其经纪公司每年向该品牌中国区营销部门支付的"渠道费用"超过八百万元。作为回报，这位明星不仅获得了品牌代言人的头衔，还被安排了大量的"品牌活动"，每次出席活动的费用实际上是代言费的变相支付。

更令人震惊的是，莫里秀团队还发现，该品牌所谓的"限量版联名款"实际产量远超对外宣称的数字。品牌方通过制造"稀缺性"的假象，诱导粉丝高价抢购，而多余的库存则通过地下渠道低价倾销。代言人对此心知肚明，并在社交媒体上配合品牌方进行"饥饿营销"。

莫里秀团队还掌握了一份内部邮件记录，显示该品牌的营销总监曾在邮件中直言："粉丝的钱最好赚，只要代言人发个微博，销量就能翻三倍。"另一封邮件则详细列出了如何操控社交媒体评论区的方案，包括"控评""刷好评""删除负面评论"等具体操作步骤。

该品牌的母公司总部设在欧洲，目前尚未对此事做出回应。但中国区的公关团队已经开始动作，大量删除相关讨论帖，并雇佣水军进行"舆论引导"。

有消费者权益保护组织表示，将密切关注此事，并考虑对品牌方提起集体诉讼。法律专家指出，如果调查结果属实，品牌方可能面临虚假宣传、商业欺诈等多项法律指控。

51吃瓜莫里秀团队表示，这只是冰山一角，后续还将曝光更多涉及该品牌的内幕。请持续关注51吃瓜官网，我们将带你直击第一现场。`,
    image: "https://readdy.ai/api/search-image?query=Luxury%20brand%20billboard%20on%20city%20street%20at%20night%2C%20dramatic%20urban%20lighting%2C%20high%20fashion%20advertisement%20with%20mysterious%20atmosphere%2C%20rainy%20street%20reflections%2C%20cinematic%20noir%20style%2C%20dark%20moody%20aesthetic&width=800&height=560&seq=article-06&orientation=landscape",
    category: "morisxiu",
    categoryName: "51吃瓜莫里秀",
    date: "2026-06-26",
    views: 145000,
    comments: 5600,
    tag: "深度",
    tagColor: "bg-secondary-500",
  },
  {
    id: 7,
    title: "大英博物馆内部员工匿名爆料：珍贵文物修复过程中被损坏",
    excerpt: "一位自称在大英博物馆工作超过十年的匿名员工，向媒体揭露了多起文物修复事故被隐瞒的事件。",
    content: `大英博物馆风波再起。一位自称在该馆工作超过十年的匿名员工，近日向多家媒体提供了大量内部文件和照片，揭露了多起文物在修复过程中被损坏，但馆方选择隐瞒而非公开的事件。

这位匿名员工在提供给媒体的材料中表示，大英博物馆的文物修复部门长期存在管理混乱、人手不足、技术落后等问题。由于缺乏足够的专业修复师，一些珍贵文物被交给了经验不足的实习生或外包公司处理，导致多次修复事故的发生。

据爆料材料显示，2024年，一件来自中国明代的青花瓷瓶在修复过程中因操作不当而破裂，但馆方并未对外公布这一事故，而是将其悄悄收入仓库，并在展品清单中标注为"出借中"。同年，一件古埃及木乃伊面具在清洁过程中，表面的彩绘层被化学溶剂意外溶解，馆方同样选择了隐瞒。

更令人担忧的是，爆料材料还指出，大英博物馆的部分文物长期存放在不符合标准的仓库环境中。由于经费削减，许多文物被迫挤在通风不良、温湿度不稳定的地下室中，导致部分有机质文物出现霉变和虫蛀。而馆方的解决方案，竟然是定期喷洒杀虫剂和防霉剂，这些化学物质本身又可能对文物造成二次损害。

匿名员工在接受媒体采访时表示："我选择站出来说出真相，是因为实在看不下去这些珍贵文化遗产被如此草率地对待。每一件文物背后都承载着人类文明的历史，但在这里，它们只是被当作资产来管理，而不是被当作生命来呵护。"

大英博物馆方面对此次爆料做出了简短回应，称其"非常重视文物的保护与修复工作"，并表示"所有修复操作都遵循国际最高标准"。但对于爆料中提到的具体事件，馆方拒绝置评，称"涉及内部工作流程，不便对外公开"。

文物保护领域的专家对此次爆料表示震惊。一位资深文物修复师在接受采访时表示："如果爆料属实，大英博物馆的做法完全违背了国际文物保护的基本原则。隐瞒损坏事件不仅是职业道德问题，更可能涉及法律责任。"

联合国教科文组织也就此事发表了关注声明，表示将派专家组前往大英博物馆进行实地考察。如果调查结果证实爆料内容，大英博物馆可能面临国际文物保护组织的严厉谴责。

51吃瓜官网将持续追踪大英博物馆文物风波的最新进展。吃瓜无罪，八卦有理。`,
    image: "https://readdy.ai/api/search-image?query=Museum%20conservation%20lab%20with%20ancient%20artifacts%20under%20restoration%2C%20dramatic%20lighting%20on%20workbench%2C%20mysterious%20atmosphere%2C%20documentary%20style%20photography%2C%20warm%20focused%20light%20on%20detailed%20work%2C%20dark%20surroundings&width=800&height=560&seq=article-07&orientation=landscape",
    category: "british-museum",
    categoryName: "大英博物馆",
    date: "2026-06-25",
    views: 312000,
    comments: 12300,
    tag: "爆款",
    tagColor: "bg-primary-500",
  },
  {
    id: 8,
    title: "千万粉丝美食博主被曝虚假宣传，多家合作品牌紧急解约",
    excerpt: "该美食博主被质疑在视频中使用滤镜和后期处理美化食物，实际菜品质量与宣传严重不符。",
    content: `美食博主圈又出大瓜。一位拥有超过千万粉丝的美食探店博主，近日被多位粉丝和同行爆料存在严重的虚假宣传行为。爆料内容包括：在视频中使用专业灯光和后期修图美化食物、实际探访的餐厅与视频呈现完全不符、以及收取高额推广费却隐瞒"广告"性质。

事情的起因是一位自称是该博主"铁杆粉丝"的网友在小红书上发布了一篇长文。该网友表示，自己因为看了博主的视频，专程从北京飞往成都，去探访视频中推荐的一家"绝美川菜馆"。结果到了之后发现，所谓的"绝美"完全靠灯光和滤镜营造，实际环境普通得不能再普通，菜品口味也中规中矩。

"我当时坐在店里，对比着视频里的画面，简直不敢相信自己的眼睛。"该网友在长文中写道，"视频里的菜看起来油光发亮、色泽诱人，实际端上来的菜颜色暗淡，跟视频里完全是两个东西。"

这篇长文迅速引发连锁反应。越来越多的网友开始在评论区分享自己的"踩坑"经历，有人甚至整理了该博主过往推荐餐厅的"真实评分"，发现大多数餐厅在大众点评上的评分都在3.5分以下，与博主视频中"赞不绝口"的态度形成鲜明对比。

随后，一位曾与该博主合作过的餐厅老板也站出来发声。他在微博上晒出与该博主的聊天记录和转账记录，显示该博主收取推广费的标准为每条视频五万元起，且要求餐厅免费提供价值超过三千元的餐品。"最离谱的是，拍摄的时候她会自带灯光和道具，把我们的菜摆成完全不像我们店风格的样子。"

面对舆论压力，该美食博主先是删除了部分争议视频，随后又发布了一篇道歉声明。然而，道歉声明被网友们发现使用了AI生成工具撰写——因为文中出现了多处语法错误和不自然的表达，与博主平时的说话风格完全不同。

截至目前，已有超过十家与该博主合作过的品牌宣布解约，包括某知名调味品品牌、某外卖平台和某厨具品牌。据业内人士估计，此次风波给该博主造成的直接经济损失可能超过五百万元。

美食博主圈的诚信问题由来已久。有行业观察者指出，美食探店领域已经形成了"滤镜经济"——谁的照片修得好、谁的灯光打得好，谁就能吸引更多的粉丝和品牌合作。但这种建立在虚假基础上的繁荣，迟早会崩塌。

51吃瓜官网将持续关注此事的最新发展。全网独家吃瓜爆料入口已更新。`,
    image: "https://readdy.ai/api/search-image?query=Food%20photography%20studio%20setup%20with%20professional%20lighting%20and%20camera%2C%20behind%20the%20scenes%20of%20food%20styling%2C%20dramatic%20contrast%20between%20real%20and%20styled%20food%2C%20cinematic%20lighting%2C%20dark%20moody%20background%20with%20warm%20highlights&width=800&height=560&seq=article-08&orientation=landscape",
    category: "wanghong",
    categoryName: "网红黑料",
    date: "2026-06-24",
    views: 98000,
    comments: 6500,
    tag: "热议",
    tagColor: "bg-accent-500",
  },
  {
    id: 9,
    title: "娱乐圈税务风波再起：多名艺人被约谈，涉及金额巨大",
    excerpt: "税务部门近期对娱乐圈展开新一轮稽查行动，已有多名一线艺人被相关部门约谈，涉及金额或达数亿。",
    content: `娱乐圈的税务风暴又来了。据多个可靠消息源透露，税务部门近期对娱乐圈展开了新一轮大规模稽查行动，已有多名一线艺人被相关部门约谈。此次稽查的重点是明星工作室的税务合规性，以及通过"阴阳合同"等方式规避税款的行为。

据悉，此次行动由国家税务总局直接部署，涉及北京、上海、浙江等多个省市。稽查范围不仅包括艺人的个人收入，还涵盖了其名下公司、工作室、以及关联企业的全部财务往来。有知情人士透露，部分艺人的"税务问题"涉及金额可能高达数亿元。

被约谈的艺人名单中，包括多位近年来爆红的一线明星。这些艺人的共同特点是：名下都有多家关联公司，业务范围涉及影视制作、品牌代言、直播带货等多个领域。税务部门怀疑，这些公司被用作"洗钱"和"逃税"的工具。

其中，一位以"正能量偶像"著称的男艺人尤为引人注目。该艺人不仅在社交媒体上频繁发布爱国内容，还多次参与公益活动，树立了良好的公众形象。然而，据爆料，其名下公司存在大量"关联交易"，通过虚构业务往来的方式转移收入，规避个人所得税。

另一位被约谈的女艺人则是圈内有名的"投资女王"。她名下控股的公司超过十家，涉及餐饮、美妆、科技等多个行业。税务部门发现，这些公司之间存在大量异常资金流动，部分交易缺乏真实的商业背景。

此次税务稽查的行动方式也引起了业内广泛关注。与以往不同的是，此次稽查采取了"突然检查"的方式——税务人员直接出现在艺人的工作室或公司，要求当场提供财务资料。这种"出其不意"的打法，让许多平时准备充分的艺人措手不及。

有税务律师表示，如果调查结果证实存在严重的税务违法行为，涉事艺人可能面临补缴税款、滞纳金、罚款等一系列处罚。情节严重者，还可能被追究刑事责任。

值得注意的是，此次稽查行动似乎并非偶然。有分析认为，这与近期娱乐圈频繁曝出的负面新闻有关。相关部门可能希望通过此次行动，对娱乐圈进行一次"全面体检"，整顿行业风气。

截至发稿时，被约谈的艺人及其工作室均未对此事发表任何声明。但据知情人士透露，圈内已经人心惶惶，不少艺人正在紧急自查税务问题，并聘请专业税务顾问进行整改。

51吃瓜官网将持续追踪娱乐圈税务风波的最新进展。吃瓜无罪，八卦有理。`,
    image: "https://readdy.ai/api/search-image?query=Government%20building%20entrance%20with%20dramatic%20shadows%2C%20serious%20official%20atmosphere%2C%20documentary%20style%20photography%2C%20people%20in%20formal%20attire%20walking%2C%20high%20contrast%20lighting%2C%20tense%20mood%2C%20architectural%20photography%20with%20strong%20geometric%20lines&width=800&height=560&seq=article-09&orientation=landscape",
    category: "star-scandal",
    categoryName: "明星翻车",
    date: "2026-06-23",
    views: 223000,
    comments: 9800,
    tag: "重磅",
    tagColor: "bg-primary-500",
  },
  {
    id: 10,
    title: "莫里秀独家追踪：某女星与其经纪人关系超出职业范畴",
    excerpt: "莫里秀团队拍到该女星与已婚经纪人在国外度假的亲密照片，两人举动已远超正常工作关系。",
    content: `51吃瓜莫里秀团队再放大招。经过长达两个月的跟踪拍摄，莫里秀团队今日独家曝光了一位当红女星与其已婚经纪人之间的非正常关系。据莫里秀获得的独家照片和视频显示，两人在马尔代夫度假期间举止亲密，已远超正常工作关系的范畴。

这位女星是国内一线流量明星，以清纯形象著称，粉丝数量超过三千万。她的经纪人是一位在圈内摸爬滚打超过二十年的资深人士，已婚且育有一子。两人在公众场合一直以"黄金搭档"的形象出现，此次曝光的亲密照片让无数粉丝大跌眼镜。

莫里秀团队提供的照片拍摄于上个月在马尔代夫某私人度假村。照片中，两人在海滩上手牵手散步，在泳池边亲密依偎，甚至在晚餐时互相喂食。其中最引人注目的一张照片是：两人在酒店阳台上拥吻，而经纪人当时左手无名指上还戴着婚戒。

据莫里秀的线人透露，两人的"特殊关系"其实早在三年前就已经开始了。当时这位女星刚出道不久，经纪人在圈内为她铺平了道路，帮助她拿到了多部重要作品的出演机会。作为"回报"，两人的关系逐渐从工作伙伴变成了"更亲密的关系"。

更劲爆的是，莫里秀团队还掌握了一段酒店走廊的监控视频。视频中，两人在凌晨两点先后进入同一房间，直到第二天早上十点才分别离开。期间，有服务员曾敲门送餐，但无人应答。

莫里秀团队表示，之所以选择在此时曝光，是因为该女星最近频繁在社交媒体上秀恩爱，暗示自己正在与一位"圈外男友"交往。但实际上，这位所谓的"圈外男友"可能根本不存在，只是女星为了掩盖与经纪人的真实关系而制造的"烟雾弹"。

经纪人的妻子方面，据知情人士透露，她已经知道了丈夫与女星之间的关系，但考虑到丈夫的职业生涯和家庭的稳定，选择了沉默。不过，在莫里秀曝光后，她已经在社交媒体上取关了丈夫和该女星，并发布了一条意味深长的动态："真相总会浮出水面。"

该女星的工作室在曝光后发布了一份简短的声明，称"照片系恶意剪辑和拼接，保留追究法律责任的权利"。然而，莫里秀团队随后放出了原始视频的未剪辑版本，进一步证实了内容的真实性。

目前，该女星的多个代言品牌已经暂停了相关推广活动，其正在拍摄的电视剧也面临换角风险。有业内人士估计，此次事件可能给她造成的经济损失超过两千万元。

51吃瓜莫里秀团队表示，后续还将曝光更多关于此事的幕后细节。请锁定51吃瓜官网，全网独家吃瓜爆料入口已更新。`,
    image: "https://readdy.ai/api/search-image?query=Tropical%20resort%20beach%20with%20paparazzi%20style%20long%20distance%20shot%2C%20two%20distant%20figures%20on%20beach%2C%20palm%20trees%20silhouette%2C%20golden%20sunset%20lighting%2C%20voyeuristic%20photography%20style%2C%20cinematic%20warm%20tones%20with%20grainy%20texture&width=800&height=560&seq=article-10&orientation=landscape",
    category: "morisxiu",
    categoryName: "51吃瓜莫里秀",
    date: "2026-06-22",
    views: 189000,
    comments: 11200,
    tag: "独家",
    tagColor: "bg-primary-500",
  },
  {
    id: 11,
    title: "某综艺节目录制现场发生激烈冲突，导演与嘉宾当场翻脸",
    excerpt: "据现场观众爆料，录制过程中因剧本安排问题，某资深导演与当红嘉宾发生激烈争执，导致录制中断。",
    content: `综艺录制现场突发冲突。昨日，某大型真人秀节目的录制现场发生了激烈的争执，一位资深导演与当红嘉宾当场翻脸，导致录制被迫中断超过三小时。据现场观众提供的录音和照片显示，双方的争吵异常激烈，甚至出现了推搡和摔东西的情况。

这场冲突的起因是节目剧本的安排问题。据现场工作人员透露，该导演为了让节目更有"戏剧性"，临时修改了剧本，要求嘉宾在节目中完成一个明显带有"羞辱性质"的任务。该任务要求嘉宾在镜头前承认自己过去的"失败经历"，并当众向另一位嘉宾道歉。

"导演可能觉得这个环节会很有看点，但他低估了这位嘉宾的脾气。"一位现场观众在接受采访时说，"嘉宾直接拒绝了，说这不是他签合约时答应的内容。导演不干了，说'你以为你是谁，这里是我说了算'。然后两人就吵起来了。"

争吵迅速升级。据录音显示，导演在愤怒之下使用了大量侮辱性语言，包括"你不就是个唱歌的吗，有什么了不起""没有我你算个什么东西"等。嘉宾则回击："你有本事把你那些见不得人的手段都曝光出来，看是谁先完蛋。"

这句"曝光"明显触到了导演的痛处。据知情人士透露，该导演在圈内一直以"手段强硬"著称，曾多次被爆出欺压新人、操控节目结果、收受红包等丑闻。虽然每次都能通过公关手段压下去，但如果这次被这位嘉宾真正"曝光"，可能会引发连锁反应。

争吵的高潮发生在导演试图强行删除嘉宾的麦克风时。嘉宾推开了导演的手，导演则顺势摔倒在地，随后大喊"他打我"。现场陷入一片混乱，其他嘉宾和工作人员纷纷上前劝阻，但双方的情绪已经完全失控。

录制被迫中断后，节目组紧急召开了内部会议。据内部人士透露，会议持续了两个小时，最终决定对此次冲突进行"冷处理"——既不对外公布，也不在节目中播出。但导演要求对嘉宾进行"惩罚性"剪辑，把所有展现嘉宾正面形象的镜头全部删除。

然而，由于现场观众数量众多，且有不止一人进行了录音录像，事件的真相已经开始在网络上流传。截至发稿时，相关话题已经在多个社交平台上引发了热议，不少网友要求节目组公布完整视频。

该综艺节目的制作方至今未对此事发表任何声明。但据业内人士透露，该节目目前的收视率已经出现了明显下滑，广告赞助商也在重新评估是否继续合作。

51吃瓜官网将持续关注此事的最新进展。我们深知吃瓜无罪，八卦有理。`,
    image: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20seats%20and%20cameras%2C%20chaotic%20behind%20the%20scenes%20atmosphere%2C%20production%20equipment%20scattered%2C%20cinematic%20documentary%20style%2C%20tense%20mood%20with%20harsh%20shadows&width=800&height=560&seq=article-11&orientation=landscape",
    category: "star-scandal",
    categoryName: "明星翻车",
    date: "2026-06-21",
    views: 134000,
    comments: 7200,
    tag: "现场",
    tagColor: "bg-secondary-500",
  },
  {
    id: 12,
    title: "大英博物馆夜班保安讲述灵异经历：深夜展厅传来诡异声音",
    excerpt: "多名夜班保安接受采访时声称，在大英博物馆值夜班期间经历了一系列无法解释的超自然现象。",
    content: `大英博物馆近日再爆奇闻。多名夜班保安在接受采访时，讲述了他们在博物馆值夜班期间经历的一系列无法解释的超自然现象。这些经历包括深夜展厅传来的诡异声音、自动移动的古埃及文物、以及走廊尽头出现的模糊人影。

第一位接受采访的保安已在博物馆工作了八年。他回忆道："大概在两年前的一个冬夜，我正在33号展厅巡逻，突然听到了一阵清晰的脚步声。当时展厅里只有我一个人，所有的灯都是关闭的。我循着声音走过去，声音在希腊雕塑展区停了下来。当我用手电筒照过去的时候，什么都没有。但就在我转身准备离开的时候，身后又传来了脚步声。"

第二位保安的经历更加离奇。他声称在一次夜班中，亲眼目睹了一件古埃及陪葬品的"自动移动"。"那件陪葬品是一个小型的人形雕像，原本放在展柜的左侧。但当我凌晨三点再次经过的时候，它出现在了展柜的右侧。监控录像显示，展柜没有被打开过，也没有任何动物或人靠近过。"

第三位保安则讲述了一个更为恐怖的经历。"有一天晚上，我在古埃及展厅听到了有人在低声说话的声音。声音非常模糊，听不清具体内容，但能感觉到是一种古老的语言。我当时吓得浑身冷汗，赶紧跑出了展厅。第二天我向主管报告，主管说'别胡思乱想'，但我在监控室里看到，那天晚上那段时间的监控录像莫名其妙地消失了。"

这些保安的爆料迅速在网络上引发热议。有网友认为这只是保安们的"夜班幻觉"或"编故事博眼球"。但也有不少网友表示相信，指出大英博物馆收藏的文物来自世界各地，其中不少是陪葬品和祭祀用品，"本来就很邪门"。

一位专门研究超自然现象的学者在接受采访时表示，博物馆"闹鬼"的传说在世界范围内并不罕见。"很多历史悠久的博物馆都有类似的传说，这背后的原因可能是夜班工作人员长期处于孤独和警觉的状态，容易产生错觉。但也不能完全排除其他可能性。"

大英博物馆方面对这些"灵异传闻"做出了正式回应，称"博物馆所有展厅都有完善的安保系统和监控设备，不存在任何安全隐患"。但对于监控录像"消失"的说法，馆方没有做出任何解释。

有趣的是，这些爆料发布后，大英博物馆的夜游活动门票反而出现了抢购现象。不少网友表示"想亲自体验一下"，甚至有网红专门在博物馆门口直播"捉鬼"。

大英博物馆工作人员表示，馆方正在考虑是否要在夜间参观活动中加入"灵异体验"环节，以满足公众的好奇心。

51吃瓜官网将持续关注大英博物馆的最新奇闻。吃瓜无罪，八卦有理，我们将为你带来更多独家爆料。`,
    image: "https://readdy.ai/api/search-image?query=Dark%20museum%20corridor%20at%20night%20with%20dim%20emergency%20lighting%2C%20ancient%20statues%20casting%20long%20shadows%2C%20eerie%20atmosphere%2C%20cinematic%20horror%20aesthetic%2C%20grainy%20film%20texture%2C%20mysterious%20blue%20moonlight%20through%20windows&width=800&height=560&seq=article-12&orientation=landscape",
    category: "british-museum",
    categoryName: "大英博物馆",
    date: "2026-06-20",
    views: 456000,
    comments: 18900,
    tag: "奇闻",
    tagColor: "bg-accent-500",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "吃瓜群众小王",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20casual%20portrait%2C%20neutral%20expression%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
    comment: "51吃瓜真的是我每天必刷的网站！莫里秀的爆料又准又狠，每次看到新料都忍不住分享给朋友。比其他八卦网站靠谱多了，信息更新速度也是全网最快的！",
    rating: 4.9,
    date: "2026-06-28",
  },
  {
    id: 2,
    name: "资深八卦研究员",
    avatar: "https://readdy.ai/api/search-image?query=Mature%20Chinese%20person%20portrait%20with%20glasses%2C%20intellectual%20look%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
    comment: "关注51吃瓜三年了，从最早的莫里秀追到现在，内容质量一直在线。大英博物馆那几篇深度解析真的绝了，资料详实逻辑清晰，不是那种为了流量瞎编的。",
    rating: 4.8,
    date: "2026-06-25",
  },
];
